import { createApiSlice } from "@common";
import {
  CRUD_CONTRACT,
  CRUD_CONTRACT_BY_ID,
  CRUD_CONTRACT_BY_OWNER,
} from "@routes";

const apiConfig = [
  {
    name: "addContract",
    method: "post",
    url: CRUD_CONTRACT,
    stateKey: "message",
  },
  {
    name: "getContract",
    method: "get",
    url: CRUD_CONTRACT,
    stateKey: "data",
  },
  {
    name: "getContractByOwner",
    method: "get",
    url: CRUD_CONTRACT_BY_OWNER,
    stateKey: "data",
  },
  {
    name: "getContractById",
    method: "get",
    url: CRUD_CONTRACT_BY_ID,
    stateKey: "details",
  },
  {
    name: "updateContract",
    method: "put",
    url: CRUD_CONTRACT,
    stateKey: "message",
  },
  {
    name: "deleteContract",
    method: "delete",
    url: CRUD_CONTRACT,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "contract",
  apiConfig,
  customReducers
);

const contractSlice = slice;
export default contractSlice.reducer;

export const {
  addContract,
  getContract,
  getContractByOwner,
  getContractById,
  updateContract,
  deleteContract,
} = thunks;

export const { rowSelect } = actions;

